import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { ToastService } from './toast.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    constructor(private toastService: ToastService) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((error: HttpErrorResponse) => {
                console.error('[HTTP Error]', error);

                // Requests made with responseType 'blob' (file downloads) get their error
                // body delivered as a Blob instead of parsed JSON, even when the backend
                // sent a JSON body — it has to be read and parsed manually.
                if (error.error instanceof Blob) {
                    return from(error.error.text()).pipe(
                        switchMap(text => {
                            let parsedBody: any = null;
                            try {
                                parsedBody = text ? JSON.parse(text) : null;
                            } catch {
                                // leave parsedBody as null if the body isn't valid JSON
                            }
                            const parsedError = new HttpErrorResponse({
                                error: parsedBody,
                                headers: error.headers,
                                status: error.status,
                                statusText: error.statusText,
                                url: error.url ?? undefined
                            });
                            if (parsedError.status !== 401) {
                                this.toastService.showError(parsedError.error);
                            }
                            return throwError(parsedError);
                        })
                    );
                }

                if (error.status !== 401) {
                    this.toastService.showError(error.error);
                }
                return throwError(error);
            })
        );
    }
}
